import React, { useRef } from "react";
import classNames from "classnames";
import { X } from "lucide-react";

function ActionIdeas({
  ideas,
  draggedIdeaId,
  touchDraggedIdeaId,
  onDragStart,
  onDragEnd,
  onTouchStart,
  onClickIdea,
  onRemoveIdea,
  isTopSpace,
}) {
  const longPressRef = useRef(null);
  const handleLongPressTouchStart = (event, idea) => {
    clearTimeout(longPressRef.current);

    longPressRef.current = setTimeout(() => {
      onTouchStart?.(event, idea);
    }, 500);
  };

  const cancelLongPress = () => {
    clearTimeout(longPressRef.current);
  };
  if (!ideas || !ideas.length) return null;
  return (
    <aside
      className="actionPlan__ideas"
      style={{ top: isTopSpace ? "150px" : "0px" }}
      aria-label="Action ideas"
    >
      <div className="actionPlan__ideas-list">
        {!ideas?.length ? (
          <div className="actionPlan__ideas-list--placeholder">
            <p>Click Generate Ideas...</p>
          </div>
        ) : (
          <>
            <p className="actionPlan__ideas-list--head actionPlan__ideas-list--head--desktop">
              drag to add
            </p>
            {ideas.map((idea) => (
              <article
                className={classNames("actionPlan__idea-card", {
                  "is-dragging": draggedIdeaId === idea.id,
                  "is-touch-dragging": touchDraggedIdeaId === idea.id,
                })}
                key={idea.id}
                role="button"
                tabIndex={0}
                draggable
                onClick={() => onClickIdea?.(idea)}
                onKeyDown={(event) => {
                  if (event.key === "Enter" || event.key === " ") {
                    event.preventDefault();
                    onClickIdea?.(idea);
                  }
                }}
                onDragStart={(event) => onDragStart(event, idea.id)}
                onDragEnd={onDragEnd}
                // 👇 touch
                onTouchStart={(e) => handleLongPressTouchStart(e, idea)}
                onTouchMove={cancelLongPress}
                onTouchEnd={cancelLongPress}
                onTouchCancel={cancelLongPress}
              >
                <button
                  type="button"
                  className="actionPlan__idea-card-close"
                  aria-label={`Remove idea ${idea.title}`}
                  onTouchStart={(e) => e.stopPropagation()}
                  onClick={(event) => {
                    event.stopPropagation();
                    onRemoveIdea?.(idea.id);
                  }}
                >
                  <X size={16} strokeWidth={2} />
                </button>
                <p>{idea.title}</p>
                <span>{idea.career}</span>
              </article>
            ))}
          </>
        )}
      </div>
      <p className="actionPlan__ideas-list--head actionPlan__ideas-list--head--mobile">
        drag to add
      </p>
    </aside>
  );
}

export default React.memo(ActionIdeas);
